export default {
    data: function () {
        return {
            submitted: false
        }
    },
    computed: {
        /**
         * get store error state
         * @returns Object
         */
      errors: function () {
          return this.$store.state.errors;
      }
    },
    methods: {
        /**
         * validate form
         * @returns {boolean}
         */
        isValid() {
            var errors = this.errors;
            // set form as submitted
            this.submitted = true;

            // check if any field which is to validate has an error
            return this.validateFields.every(function (error) {
                return errors[error] === false;
            });
        }
    }
}